import React from 'react';

function FeedbackAnticipateInstallmentIcon() {
  return (
    <svg width={22} height={22} fill="none">
      <title>Ilustração de relógio anti-horário</title>
      <path
        d="M4.27.615l-.954.113.464 3.916 3.916.464.113-.953-2.81-.333a8.287 8.287 0 012.243-1.284C8.371 2.104 9.635 1.88 11 1.88c1.365 0 2.63.224 3.757.658a8.153 8.153 0 012.864 1.841 8.162 8.162 0 011.841 2.863c.434 1.129.658 2.393.658 3.758 0 1.365-.224 2.629-.658 3.758a8.161 8.161 0 01-1.841 2.863 8.153 8.153 0 01-2.863 1.84c-1.129.435-2.393.659-3.758.659-1.365 0-2.63-.224-3.757-.658a8.153 8.153 0 01-2.864-1.841 8.163 8.163 0 01-1.841-2.863C2.104 13.629 1.88 12.365 1.88 11H.92c0 1.48.244 2.86.722 4.102A9.123 9.123 0 003.7 18.3a9.111 9.111 0 003.197 2.059c1.24.477 2.621.722 4.102.722 1.48 0 2.861-.245 4.102-.722a9.11 9.11 0 003.197-2.059 9.121 9.121 0 002.06-3.196c.476-1.242.72-2.623.72-4.103 0-1.48-.244-2.86-.72-4.102a9.121 9.121 0 00-2.06-3.197 9.111 9.111 0 00-3.197-2.059C13.862 1.165 12.48.92 11 .92c-1.48 0-2.861.245-4.102.722a9.277 9.277 0 00-2.351 1.314L4.269.615z"
        fill="#111"
      />
      <path
        d="M10.945 11.336l-4.47-3.13-.55.787 5.13 3.591 5.564-5.565-.678-.678-4.996 4.995z"
        fill="#111"
      />
    </svg>
  );
}

export default FeedbackAnticipateInstallmentIcon;
